module.exports = __webpack_public_path__ + "static/media/Revolution.0c446656.png";